import type { RefObject } from 'react';
import { TAB_AS_NBSP } from '@root/helpers/editor';
import { Fragment, Slice } from '@tiptap/pm/model';
import type { EditorView } from '@tiptap/pm/view';

const replaceTabs = (text: string) => text.replaceAll('\t', TAB_AS_NBSP);

export const createPasteEditorProps = (unformattedPasteRef: RefObject<boolean>) => ({
  transformPastedText: replaceTabs,
  handlePaste(view: EditorView, event: ClipboardEvent, _slice: unknown) {
    if (unformattedPasteRef.current) {
      const text = replaceTabs(event?.clipboardData?.getData('text/plain') ?? '');
      const textFragment = Fragment.from(view.state.schema.text(text));
      const textSlice = new Slice(textFragment, 0, 0);
      //https://github.com/ProseMirror/prosemirror-view/blob/75c930281c4c45c214df750dd367c17efc315b8f/src/input.js#L542
      const singleNode =
        textSlice.openStart == 0 && textSlice.openEnd == 0 && textSlice.content.childCount == 1
          ? textSlice.content.firstChild
          : null;
      //https://github.com/ProseMirror/prosemirror-view/blob/75c930281c4c45c214df750dd367c17efc315b8f/src/input.js#L566
      const tr = singleNode
        ? view.state.tr.replaceSelectionWith(singleNode, (view as any).shiftKey)
        : view.state.tr.replaceSelection(textSlice);
      view.dispatch(tr.scrollIntoView().setMeta('paste', true).setMeta('uiEvent', 'paste'));
      return true;
    } else return false;
  },
});
